import {useContext, useMemo} from 'react'
import {AuthContext} from '@/context/Auth/AuthContext'
import { readUserFromClaims, readUserFromStorage } from '@/utils/authClaim'

/**
 * Resolves the signed-in user's identity for use in audit fields (e.g. `uploadedBy`).
 * Uses live MSAL claims when available and falls back to the stored shell token.
 * @returns {{firstName: string, lastName: string, email: string, userId: string, displayName: string, claims: Object}}
 */
export const useCurrentUser = () => {
	const {account, claims} = useContext(AuthContext)
	const hasClaims = Object.keys(claims).length > 0

	return useMemo(
		() => hasClaims ? readUserFromClaims(claims, account?.username) : readUserFromStorage(),
		[account?.username, claims, hasClaims],
	)
}

export default useCurrentUser
